import { WSButton } from "@wingspanhq/fe-component-library";
import { useHistory } from "react-router-dom";
import { NotificationTemplate } from "../index";
import { useRequirementInstructionsModal } from "../../../../Requirements/components/RequirementsDetails/useRequirementInstructionsModal";
import { useGoToDashboardPayerRequirementDetails } from "../../../routes/RouteRequirementDetails/RoutePayerRequirementDetails";

export interface InsuranceCoverageMonitoringContractorContext {
  requirement: {
    name: string;
    requirementId: string;
  };
  payer: {
    payerId: string;
    payerName: string;
    logoFileId?: string;
  };
}

const GROUP_THRESHOLD = 2;

export const InsuranceCoverageMonitoringContractor: NotificationTemplate<InsuranceCoverageMonitoringContractorContext> =
  {
    renderTitle: props =>
      props.group.length >= GROUP_THRESHOLD
        ? "Multiple insurance proofs requested"
        : "Proof of insurance requested",
    renderBody: props => {
      if (props.group.length >= GROUP_THRESHOLD) {
        const payerNames = new Set(
          props.group.map(item => item.context.payer.payerName)
        );
        const payerNamesString = Array.from(payerNames).join(", ");

        return `Proofs of insurance requested by ${payerNamesString}`;
      }

      return (
        <>
          <b>{props.context.requirement.name}</b> insurance requested by{" "}
          <b>{props.context.payer.payerName}</b>.
        </>
      );
    },
    Footer: props => {
      const goToPayerRequirementDetails =
        useGoToDashboardPayerRequirementDetails();
      const instructionsRequirementModal = useRequirementInstructionsModal();

      const history = useHistory();

      if (props.group.length >= GROUP_THRESHOLD) {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onClick={() => {
              history.push("/member/dashboard/contractor-insurance-coverages");
            }}
          >
            View requirements
          </WSButton.Link>
        );
      } else {
        return (
          <WSButton.Link
            size="S"
            rightIcon="chevron-right"
            onAsyncClick={async () => {
              const instructionsResult =
                await instructionsRequirementModal.open({
                  requirementId: props.context.requirement.requirementId
                });

              if (instructionsResult !== true) return;

              goToPayerRequirementDetails({
                requirementId: props.context.requirement.requirementId,
                payerId: props.context.payer.payerId
              });
            }}
          >
            Complete requirement
          </WSButton.Link>
        );
      }
    }
  };
